import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'
import { z } from 'zod'

const scheduleSearchSchema = z.object({
  view: z.enum(['day', 'week', 'month', 'year']).optional().default('week'),
  date: z.string().optional(), // ISO date string (YYYY-MM-DD)
})

export const Route = createFileRoute('/app/schedule')({
  validateSearch: scheduleSearchSchema,
  component: lazyRouteComponent(() => import('./-schedule')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
